import { GET_CESIUM, GET_CESIUM_ERROR, GET_CESIUM_SUCCESS } from './CesiumMap.actions'

const cesiumState = {
  loading: true,
  error: false,
  urlData: []
}

const cesiumReducer = (state = cesiumState, { payload, type }) => {
  switch (type) {
    case GET_CESIUM: {
      return { ...state, loading: true, error: false }
    }
    case GET_CESIUM_SUCCESS: {
      return { ...state, loading: false, error: false, urlData: payload.urlData }
    }
    case GET_CESIUM_ERROR: {
      return { ...state, loading: false, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default cesiumReducer
